import { useState } from 'react';
import { di } from 'react-magnetic-di';
var VIEW_CONFIGURATIONS = new Map();

/**
 * Loads view configuration for a given view type.
 *
 * @internal Use useLoadViewConfiguration hook.
 */
export var loadViewConfiguration = function loadViewConfiguration(viewType, configuration) {
  if (!VIEW_CONFIGURATIONS.has(viewType)) {
    VIEW_CONFIGURATIONS.set(viewType, configuration);
  }
};

/**
 * Returns view configuration for a given view type.
 */
export var getViewConfiguration = function getViewConfiguration(viewType) {
  return VIEW_CONFIGURATIONS.get(viewType);
};

/**
 * Clears view configurations.
 *
 * @internal For tests only.
 */
export var clearViewConfigurations = function clearViewConfigurations() {
  VIEW_CONFIGURATIONS.clear();
};

/**
 * Loads UI modifications view configuration once.
 */
export var useLoadViewConfiguration = function useLoadViewConfiguration(viewType, configurationClass) {
  /**
   * Uses useState to load view configuration on component mount, before rendering.
   */
  useState(function () {
    loadViewConfiguration(viewType, new configurationClass());
  });
};